module.exports = __webpack_public_path__ + "static/media/logo.803ecec7.png";